export const appearanceConstants = {
  dateFormat: 'DD MMM YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
  hourFormat: 'HH:mm',
  dayOfWeek: '0',
  timeToDateInput: 'YYYY-MM-DD'
}
